<template>
  <section class="full viz-container">
    <h2>{{ msg }}</h2>
    <select d="colorSource" v-model="colorSource" @change="redrawViz()">
      <option disabled value>
        Please select the color source
      </option>
      <option value="1">
        Unsplash
      </option>
      <option value="2">
        Main Color
      </option>
      <option value="3">
        Color Palette
      </option>
    </select>
    <div class="creditBox">
      <div class="credits" v-if="displayCredit">
        <a :href="unsplashUsernameURL" target="_blank">This photo was contributed by {{ unsplashUsernameName }}</a> on
        <a :href="unsplashURL" target="_blank">Unsplash</a>
        <div @click="removeImage" class="close icofont-close" />
      </div>
    </div>
    <div v-if="!dataLoaded" class="preloader">
      <img v-if="!dataLoaded" class="wait" ssrc="/assets/images/ajax-loader.gif" alt="... won't be long ...">
      <p>... won't be THAT long ...</p>
    </div>
    <div id="color-viz" class="d3-viz color-viz">
      <div id="tooltip" @click="displayImageInShowbox($event)" class="tooltip">
        <div class="pointer" id="pointer"> 
          <p class="view" id="view-btn">
            View
          </p>
        </div>
        <div @click.stop="removeToolTip" class="close icofont-close" />
        <div class="palette">
          <div id="p1" />
          <div id="p2" />
          <div id="p3" />
          <div id="p4" />
          <div id="p5" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ColorViz from "../js/color/d3-color"
import Helper from "../js/d3-common"
import Action from "../js/color/d3-color-params"

export default {
    name: "ColorViz",
    data() {
        return {
            dataLoaded: false,
            data: null,
            displayCredit: false,
            unsplashUsernameURL: "",
            unsplashURL: "",
            unsplashUsernameName: "",
            colorSource: 1
        }
    },
    props: {
        msg: {
            type: String,
            default: "Message not defined"
        }
    },
    created() {

        this.data = ColorViz.loadData("unsplash-colors-combined").then(json => {
            this.dataLoaded = true
            ColorViz.drawBase("color-viz", json)
            ColorViz.drawContent(json, this.colorSource)
            this.data = json
            

            // load starting image
            // const imgEl = document.getElementById("app")
            // const firstShotURL = "https://unsplash.com/photos/TcCjnohtRnA/download"
            // imgEl.style.backgroundImage = "url(" + firstShotURL + ")"
        })
    },
    methods: {
        removeToolTip() {
            Action.hideToolTip()
        },
        redrawViz() {
            ColorViz.drawBase("color-viz", this.data)
            ColorViz.drawContent(this.data, Number(this.colorSource))
        },
        displayImageInShowbox(event) {
            const id = event.target.dataset.id
            const photo = this.data.find(obj => obj.id == id)

            const imgEl = document.getElementById("app")
            const pointer = document.getElementById("pointer")
            const tempImage = pointer.style.backgroundImage

            const innerWidth = window.innerWidth
            const innerHeight = window.innerHeight
            pointer.style.backgroundImage = "url('/assets/images/loading.gif')"

            Helper.loadImage(
                `${
                    photo.urls.raw
                }&w=${innerWidth}&h=${innerHeight}&fit=crop&q=85&fm=jpg&crop=entropy&cs=srgb`
            ).then(img => {
                const photoURL = img.src
                imgEl.style.backgroundImage = "url(" + photoURL + ")"
                pointer.style.backgroundImage = tempImage

                this.displayCredits(photo)
            })
        },
        displayCredits(photoData) {
            let utmStr = "?utm_source=discover-unsplas&utm_medium=referral&utm_campaign=color"
            this.unsplashUsernameURL =
        "//unsplash.com/@" + photoData.user.username + utmStr
            this.unsplashURL = "https://unsplash.com/" + utmStr
            this.unsplashUsernameName = `${photoData.user.first_name} ${
                photoData.user.last_name
            }`
            this.displayCredit = true
        },
        removeImage(photoData) {
            const imgEl = document.getElementById("app")
            imgEl.style.backgroundImage = ""

            this.removeToolTip()
            this.displayCredit = false
        }
    }
}
</script>

<style scoped lang="stylus">
.creditBox {
  margin: 0 auto;
  text-align: center;
}

.credits {
  font-size: 14px;
  background: rgba(255, 255, 255, 0.7);
  padding: 8px 20px;
  border: 1px solid maroon;
  margin: 5px auto;
  display: inline;
  padding: 8px 25px;
  position: relative;

  & .close {
    position: absolute;
    width: 20px;
    height: 20px;
    line-height: 21px;
    top: 2px;
    right: -12px;
    border-radius: 20px;
    border: 4px solid darkgrey;
    background-color: white;
    cursor: pointer;
    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.8);
  }
}

.wrapper {
  fill: none;
  stroke: #646464;
  stroke-width: 1px;
  stroke-dasharray: 2, 2;
  stroke-linejoin: round;
}

.full {
  text-align : center
  & div {
    // width: 100%;
  }

  & .preloader {
      margin: 100px auto
      text-align : center
    }

  & .d3-viz {
    width: 100%;
    height: 80vh;
    margin: 0 auto;
    text-align: center;

    & .tooltip {
      position: absolute;
      z-index: 3;
      // width: 200px;
      opacity: 0;

      & .pointer {
        position: relative;
        width: 150px;
        height: 150px;
        background-size: cover;
        display: block;
        border-radius: 80px;
        border: 4px solid darkgrey;

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 15px;
          height: 15px;
          background: darkgrey;
          border-top-color: transparent;
          border-left-color: transparent;
          transform: translate(-50%, 50%) rotate(45deg);
          transform-origin: center center;
          z-index: -2;
        }

        &:hover {
          cursor: pointer;

          & p.view {
            background: rgba(255, 255, 255, 0.85);
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
          }
        }

        & p.view {
          font-family: 'Muli', sans-serif;
          font-weight: 600;
          font-size: 14px;
          margin: 60px 20px 0;
          padding: 3px;
          z-index: 3;
          color: black;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 5px;
          transition: all 0.2s ease-out;
        }
      }

      & .palette {
        position: absolute
        top: 8px
        left: -10px
        // border: 1px solid red

        & div {
          border: 1px solid black
          margin: 5px 0
          width: 20px
          height: 20px
          border-radius: 12px;
          background-color : white
        }
      }

      & .close {
        position: absolute;
        width: 20px;
        height: 20px;
        line-height: 21px;
        top: 15px;
        right: 5px;
        border-radius: 20px;
        border: 4px solid darkgrey;
        background-color: white;
        cursor: pointer;
      }
    }
  }
}
</style> 
